import {
    Button,
    Checkbox,
    TextContainer,
    FormLayout,
    Banner,
    InlineError,
    Modal,
    Select,
    Stack,
    TextField
} from "@shopify/polaris";

import {useCallback, useState} from "react";


import Axios from "axios";

export default function CloseFulfillmentOrderModal(props) {

    const [active, setActive] = useState(false);
    const handleChange = useCallback(() => {
        setActive(!active)
        setErrorResponding(false)
    }, [active]);

    const [spinner, setSpinner] = useState(false)
    const [choiceConfirmed, setChoiceConfirmed] = useState(false)
    const handleChoiceConfirmed = useCallback(newChecked => setChoiceConfirmed(newChecked), [])

    const [selected, setSelected] = useState("")
    const handleSelectChange = useCallback((value) => {
        setSelected(value)
        handleChoiceConfirmed(false)
    }, [handleChoiceConfirmed])

    const [otherOption, setOtherOption] = useState("")
    const [otherRequiredMessage, setOtherRequiredMessage] = useState(false)
    const handleOtherChange = useCallback((value) => {
        value = value.trimStart()
        setOtherOption(value)
        handleChoiceConfirmed(false)
        if (value.length === 0)
            setOtherRequiredMessage(true)
        else
            setOtherRequiredMessage(false)
    }, [handleChoiceConfirmed])

    const [errorResponding, setErrorResponding] = useState(false)

    const activator = <Button destructive={true} onClick={handleChange}>Close Fulfillment Order</Button>;

    const submitRequest = useCallback(async () => {
        try {
            await Axios.post("fulfillmentOrders/closeFulfillmentOrder", {
                id: props.id,
                message: selected.toLowerCase() === "other" ? otherOption : selected
            },  {
                baseURL: process.env.REACT_APP_BASE_URL,
                withCredentials: true,
            })
        } catch (e) {
            setErrorResponding(true)
            return
        }

        props.setToastContent("Fulfillment order closed")
        props.toggleToastActive()
        setActive(false)
        await props.updateFulfillmentOrder()

    }, [props, selected, otherOption])


    return (
        <>
            <Modal
                activator={activator}
                open={active}
                onClose={handleChange}
                title={"Close fulfillment order?"}
                footer={errorResponding && <InlineError message={"An error has occurred trying to communicate with the Shopify service"} fieldID={"rejectError"} />}
            >
                <Modal.Section>
                    <FormLayout>
                        <Banner status={"critical"}>
                            <TextContainer>
                                <p>Are you sure you want to close this fulfillment order?
                                    Any remaining unfulfilled items cannot be fulfilled once you close the order. All fulfilled items will not be affected.</p>
                                {/*<p>If you would like to fulfill these items later, you should place a hold on this order using the "Hold Remaining Items" button instead.</p>*/}
                            </TextContainer>
                        </Banner>
                        <Select
                            label={"Close reason"}
                            options={[
                                {label: "Awaiting payment", value: "AWAITING_PAYMENT"},
                                {label: "High risk of fraud", value: "HIGH_RISK_OF_FRAUD"},
                                {label: "Incorrect address", value: "INCORRECT_ADDRESS"},
                                {label: "Inventory out of stock", value: "INVENTORY_OUT_OF_STOCK"},
                                {label: "Other", value: "other"}
                            ]}
                            onChange={handleSelectChange}
                            placeholder={"Select"}
                            requiredIndicator
                            value={selected}
                        />
                        {selected.toLowerCase() === "other" &&
                            <TextField
                                label={"Other"} autoComplete={"off"}
                                value={otherOption} onChange={handleOtherChange}
                                requiredIndicator
                                error={otherRequiredMessage && "This field is required"}
                                onBlur={() => {
                                    if (otherOption.length === 0)
                                        setOtherRequiredMessage(true)
                                }}
                            />
                        }

                        <Checkbox
                            label={"Confirm choice"}
                            disabled={!selected || (selected.toLowerCase() === "other" && otherOption.length === 0)}
                            checked={choiceConfirmed}
                            onChange={handleChoiceConfirmed} />
                    </FormLayout>
                </Modal.Section>
                <Modal.Section>
                    <Stack distribution={"trailing"}>
                        <Button destructive loading={spinner} disabled={!choiceConfirmed} onClick={async () => {
                            setSpinner(true)
                            await submitRequest()
                        }}>Close Fulfillment Order</Button>
                    </Stack>
                </Modal.Section>
            </Modal>
        </>


    );
}